<template>
    <section v-if="infoDay != null" id="content">
      <div id="day">
        <div id="bg">
          <div class="content">
             <img :src="require('@/assets/'+infoDay.data.weather[0].main.toLowerCase()+'.jpg')">
          </div>
        </div>
        <h1>
          {{ infoDay.data.name }}
          <small>, {{ infoDay.data.sys.country }}</small>
        </h1>
        <h2>{{ Math.round(infoDay.data.main.temp) }}°</h2>
        <div class="minmaxtemp">
          <span>
            min:
            <b>{{ Math.round(infoDay.data.main.temp_min) }}°</b>
          </span>
          <span>
            max:
            <b>{{ Math.round(infoDay.data.main.temp_max) }}°</b>
          </span>
        </div>
        <h3>{{ infoDay.data.weather[0].description }}</h3>
      </div>
       <div id="list" v-if="infoForeCast">
        <ul>
          <li v-for="(item, index) in infoForeCast.data.daily" :key="index" class="item-list">
            <p class="day">{{ momentDate(item.dt) }}</p>
            <img :src="'https://openweathermap.org/img/wn/' + item.weather[0].icon + '.png'" alt="">
            <p class="temp">{{ item.temp.day }}°</p>
          </li>
        </ul>
      </div>
    </section>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import { gsap } from "gsap";

export default {
  name: "HomeResult",
  mounted() {
    setTimeout(() => {
      this.animReady();
    }, 300);
  },
  computed: {
    ...mapState(["isReady", "infoDay", "infoForeCast"])
  },
  methods: {
    animReady() {
      let tl = gsap.timeline({ duration: 0.1 });
      tl.fromTo(
        "h1, h2, #bg, .minmaxtemp, h3, .item-list",
        { opacity: 0, y: -10 },
        { opacity: 1, y: 0, stagger: 0.1}
      );
    },

    momentDate(value) {
      moment.locale("fr");
      return moment.unix(value).format("dddd");
    }
  }
};
</script>

<style lang="scss">
@import "../scss/global";
@import "../scss/components/homeResult";
</style>